import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.6569 9.5632c-.872-.0568-1.6681-.019-2.7107.0758-.4359.0379-.6065-.5683-.5118-1.4964.1327-1.61.3223-2.7465.455-3.6747.2654-1.6668-2.1041-1.951-2.6159-.663-.4928 1.2313-1.8576 5.5878-4.4925 6.8001-.3033.1326-.4928.4546-.4928.7955 0 1.4206 0 4.9438-.019 6.4212 0 .3978.2654.7387.6445.8524C10.3923 19.0719 14.0696 20 16.6666 20c1.687 0 2.6727-.1326 3.0328-1.7047.3792-1.648.853-4.0725 1.2132-5.9477.3791-2.0078-.4928-2.6707-2.2557-2.7844m-11.7331.6429H3.417c-.2274 0-.417.1894-.417.4167v8.2395c0 .2273.1896.4168.417.4168h3.5068c.2275 0 .417-.1895.417-.4168v-8.2395c0-.2273-.1895-.4167-.417-.4167m-1.763 7.727c-.436 0-.7771-.3409-.7771-.7766s.3412-.7766.7771-.7766.7772.341.7772.7766c0 .4357-.3412.7766-.7771.7766",
    clipRule: "evenodd"
}), "StatusApproved", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
